module.exports = __webpack_public_path__ + "img/imgPdtInfo3.e0ef6ee6.png";